export const telephonyTr = {
  admin: {
    title: 'Telefon ve Yapay Zeka kontrol merkezi',
    subtitle: 'Ses işleme, transkripsiyon hizmeti, dil modeli ve kullanıcı başına aktivasyon.',
    tabEngine: 'Ses ve Yapay Zeka motoru',
    tabUsers: 'Kullanıcı aktivasyonu',
    error: 'Yapılandırma yüklenemedi.',
    saved: 'Yapılandırma kaydedildi.',
    engineTitle: 'Ses ve STT motoru',
    engineHint:
      'Kayıt çağrıdan sonra getirilir, yazıya dökülür ve ardından dil modeli tarafından analiz edilir.',
    enabled: 'Yapay zeka analizi aktif',
    enabledHint: 'Analiz kapatıldığında, kayıtlar yalnızca günlüğe kaydedilir.',
    mode: 'Ses işleme modu',
    modeHint:
      'Otomatik algılama kanal sayısına göre seçim yapar: stereo kanal başına kopyalanır, mono ise hoparlör günlüğü ile ayrılır.',
    whisperUrl: "Whisper / WhisperX API URL'si",
    whisperKey: 'Whisper kimlik doğrulama jetonu',
    ollamaUrl: "Ollama sunucu URL'si",
    ollamaUrlHint:
      'Yerel olarak "http://localhost:11434" veya ağ üzerinde "http://192.168.1.50:11434".',
    ollamaModel: 'Ollama modeli',
    prompt: 'Çıkarma istemi',
    promptHint: '{{transcript}} yer tutucusu, biçimlendirilmiş konuşmacı metni ile değiştirildi.',
    secretSet: 'Saklandı ({{hint}}). Boş bırakmak kayıtlı değeri korur.',
    secretUnset: 'Saklanan jeton yok.',
  },
  modes: {
    AUTO_DETECT: 'Otomatik algılama (stereo → daha hızlı fısıltı / mono → WhisperX)',
    STEREO_SPLIT_FASTER_WHISPER: 'Zorunlu: stereo çift kanal (daha hızlı fısıltı)',
    MONO_DIARIZATION_WHISPERX: 'Zorunlu: mono hoparlör günlük kaydı (WhisperX)',
    SINGLE_CHANNEL_PLAIN: 'Hoparlör ayrımı olmayan düz mono',
  },
  test: {
    title: 'Ardışık düzen testi',
    subtitle:
      'Bir test dosyası yükleyin ve format algılama, transkripsiyon ve özet zincirinin tamamını doğrulayın.',
    upload: 'Test dosyasını yükleyin ve STT/LLM hattını doğrulayın',
    running: 'Boru hattı çalışıyor. Uzunluğa bağlı olarak bu birkaç dakika sürer.',
    success: 'İşlem hattı başarıyla tamamlandı.',
    failed: 'Ardışık düzen bir hatayla sona erdi.',
    tooLarge: "Test dosyası {{size}} MB'yi aşıyor.",
    transcript: 'Transkript',
    summary: 'Özet',
    checkedAt: "{{timestamp}}'de kontrol edildi",
    steps: {
      ANALYSIS: 'Format algılama',
      TRANSCRIPTION: 'Transkripsiyon',
      SUMMARY: 'Özet',
    },
  },
  users: {
    title: 'Kullanıcı başına aktivasyon',
    subtitle:
      'Telefon yalnızca kullanıcı hesabı başına etkinleştirilir. Temsilci kimliği, doğrudan arama numarası veya dahili numara olmadan gelen çağrılar eşleştirilemez.',
    error: 'Kullanıcı listesi yüklenemedi.',
    empty: 'Kullanıcı yok.',
    saved: 'Aktivasyon kaydedildi.',
    user: 'Çalışan',
    providerUserId: 'Temsilci kimliği',
    providerUserIdHint: 'Çalma kullanıcı kimliği, örneğin 1234567.',
    numbers: 'Telefon numaraları',
    extension: 'Dahili uzantı',
    extensionPlaceholder: '101',
    directDial: 'Doğrudan arama (E.164)',
    directDialPlaceholder: '+4961421234512',
    outboundCallerId: 'Giden CLI',
    outboundCallerIdPlaceholder: '+496142123450',
    outboundCallerIdHint: 'Aranan kişiye gösterilen numara.',
    apiKey: 'Kişisel API anahtarı',
    apiKeyPlaceholder: 'Yeni bir anahtar girin',
    apiKeySet: 'Saklandı ({{hint}}). Kaydedilen değeri korumak için boş bırakın.',
    apiKeyUnset: 'Kayıtlı anahtar yok.',
    showKey: 'Anahtarı göster',
    hideKey: 'Anahtarı gizle',
    enabled: 'Aktif',
    toggle: '{{name}} için telefonu etkinleştirin',
    test: 'Testi',
    testHint: 'Saklanan kimlik bilgilerini kullanarak bağlantıyı kontrol edin',
    testRunning: 'Bağlantı testi çalışıyor.',
    testSuccess: 'Bağlantı kuruldu: {{name}}',
    testSuccessAnonymous: 'Sağlayıcıyla bağlantı çalışıyor.',
    providerHint: 'Desteklenen sağlayıcılar: {{providers}}.',
  },
  webhook: {
    title: 'Ringover webhook uç noktası',
    hint: "Arama etkinliklerini ve kayıtlarını gerçek zamanlı olarak almak için bu URL'yi ve sırrı Ringover geliştirici kontrol paneline girin.",
    url: "Web kancası URL'si",
    copy: 'Kopyala',
    copied: "Webhook URL'si kopyalandı.",
    copyFailed: 'URL kopyalanamadı. Lütfen manuel olarak seçin.',
    secret: 'Küresel web kancası sırrı',
    secretPlaceholder: 'Yeni bir sır girin',
    secretHint:
      'Tüm gelen teslimatlar için imzalama anahtarı. Ringover entegrasyon başına tam olarak bir sır kullandığından kurulumun tamamı için geçerlidir.',
    secretSet: 'Saklandı ({{hint}}). Kaydedilen değeri korumak için boş bırakın.',
    secretUnset: 'Henüz saklanan bir sır yok — gelen teslimatlar reddediliyor.',
    masterKey: 'Ringover yönetici API anahtarı (isteğe bağlı)',
    masterKeyHint: 'Kurulum çapındaki sorgular için kullanılır ve kesinlikle gerekli değildir.',
    save: 'Kaydet',
    saved: 'Sağlayıcı yapılandırması kaydedildi.',
    error: 'Sağlayıcı yapılandırması yüklenemedi.',
  },
  list: {
    subtitle:
      'Transkript ve yapay zeka analizi de dahil olmak üzere bu iş ortağıyla yapılan görüşmeler.',
    error: 'Arama geçmişi yüklenemedi.',
    emptyTitle: 'Henüz kayıtlı arama yok',
    emptyHint: 'Bir çağrı yapılır yapılmaz burada görünecektir.',
    selectHint: 'Analizini görmek için bir çağrı seçin.',
    showTranscript: 'Transkripti göster',
    callNow: "{{number}}'yi ara",
    noPermission: 'Arama geçmişini görüntülemenize izin verilmiyor.',
  },
  fields: {
    startedAt: 'Zaman',
    direction: 'Yön',
    agent: 'Temsilci',
    status: 'Durum',
    duration: 'Süre (dk)',
    actions: 'İşlemler',
  },
  directions: {
    INBOUND: 'Gelen',
    OUTBOUND: 'Giden',
  },
  statuses: {
    RINGING: 'Çalıyor',
    ANSWERED: 'Yanıtlandı',
    MISSED: 'Kaçırıldı',
    VOICEMAIL: 'Sesli Posta',
    FAILED: 'Başarısız',
  },
  sentiments: {
    POSITIVE: 'Olumlu',
    NEUTRAL: 'Nötr',
    NEGATIVE: 'Negatif',
    DISPUTED: 'Tartışmalı',
  },
  processing: {
    PENDING: 'Analiz sıraya alındı.',
    DOWNLOADING_AUDIO: 'Kayıt getiriliyor…',
    TRANSCRIBING: 'Çağrı yazıya aktarılıyor…',
    SUMMARIZING: 'Dil modeli özetliyor…',
    COMPLETED: 'Analiz tamamlandı.',
    FAILED: 'Analiz başarısız oldu.',
    DISABLED: 'Yapay zeka analizi sistem genelinde kapatıldı.',
  },
  summary: {
    title: 'Yapay zeka özeti',
    empty: 'Bu çağrı için özet mevcut değil.',
    edit: 'Özeti düzenle',
    editorLabel: 'Özet',
    saved: 'Özet kaydedildi.',
    editedBadge: "{{name}} tarafından {{timestamp}}'de düzenlendi",
    showOriginal: 'Orijinal AI metnini göster',
    actionItems: 'Eylem öğeleri',
    reprocess: 'Analizi yeniden başlat',
    reprocessStarted: 'Analiz yeniden başlatıldı.',
  },
  transcript: {
    title: 'Çağrı metni',
    subtitle: 'İşleme modu: {{mode}}',
    modeUnknown: 'bilinmiyor',
    empty: 'Bu çağrı için transkript mevcut değil.',
    showPlain: 'Düz metin',
    showDialog: 'Diyalog',
    agent: 'Temsilci',
    customer: 'Müşteri',
  },
  screenPop: {
    title: 'Gelen çağrı',
    unknown: 'Bu numara için muhatap kayıtlı değil.',
    openDocuments: '{{count}} belgeleri aç',
    lastCall: 'Son çağrı: {{timestamp}}',
    open: 'Kişiyi aç',
    blockedTitle: '🚨 Kilitli: {{status}}',
    blockedReason: 'Sebep: {{reason}}',
  },
  call: {
    started: 'Arama başlatıldı. Lütfen cihazınızdan yanıtlayın.',
    failed: 'Arama başlatılamadı: {{message}}',
  },
} as const;
